import React from "react";

export default function IconDistributor() {
  return (
    <svg
      id="fi_4363525"
      enableBackground="new 0 0 58 58"
      height="50"
      viewBox="0 0 58 58"
      width="50"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path d="m49.17 17.948c1.853 3.375 2.83 7.165 2.83 11.052 0 .361-.028.724-.044 1.087.341-.052.688-.087 1.044-.087.325 0 .643.03.956.073.015-.358.044-.716.044-1.073 0-4.558-1.244-8.989-3.58-12.871-.292.515-.617 1.012-.985 1.48z"></path>
        <path d="m19.37 8.115c2.93-1.357 6.06-2.065 9.326-2.106.246-.694.551-1.359.915-1.989-3.877-.089-7.813.738-11.327 2.403.439.506.806 1.075 1.086 1.692z"></path>
        <path d="m9.103 17.471-1.289-1.719c-2.311 3.688-3.605 7.887-3.777 12.248h2c.16-3.726 1.203-7.322 3.066-10.529z"></path>
        <path d="m44.725 45.775.546 2.184c1.49-1.279 2.819-2.721 3.969-4.307l-1.262-1.682c-.948 1.383-2.032 2.66-3.253 3.805z"></path>
        <path d="m28 30h-8v7.618l-5-2.5-5 2.5v-7.618h-8v20h2.685c1.126-2.361 3.53-4 6.315-4s5.189 1.639 6.315 4h10.685z"></path>
        <path d="m17.92 52c.047.328.08.66.08 1s-.033.672-.08 1h10.16c-.047-.328-.08-.66-.08-1s.033-.672.08-1z"></path>
        <path d="m42.219 44h-6.219c-1.103 0-2-.897-2-2v-2c0-1.103.897-2 2-2h4.719l-.311-1.243c-.111-.445-.51-.757-.97-.757h-9.438v12.111c1.272-1.301 3.042-2.111 5-2.111 2.785 0 5.189 1.639 6.315 4h2.404z"></path>
        <path d="m0 52v2h4.08c-.047-.328-.08-.66-.08-1s.033-.672.08-1z"></path>
        <path d="m11 48c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5zm0 7c-1.105 0-2-.895-2-2s.895-2 2-2 2 .895 2 2-.895 2-2 2z"></path>
        <path d="m12 34.382 3-1.5 3 1.5v-4.382h-6z"></path>
        <path d="m35 48c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5zm0 7c-1.105 0-2-.895-2-2s.895-2 2-2 2 .895 2 2-.895 2-2 2z"></path>
        <path d="m36 42h5.719l-.5-2h-5.219z"></path>
        <path d="m42 53c0 .34-.033.672-.08 1h2.08v-2h-2.08c.047.328.08.66.08 1z"></path>
        <path d="m13 19.333 4-5.334c.645-.858 1-1.924 1-2.999 0-2.757-2.243-5-5-5s-5 2.243-5 5c0 1.075.355 2.141 1 2.999zm0-10.333c1.105 0 2 .895 2 2s-.895 2-2 2-2-.895-2-2 .895-2 2-2z"></path>
        <path d="m53 32c-2.757 0-5 2.243-5 5 0 1.075.355 2.141 1 2.999l4 5.334 4-5.334c.645-.858 1-1.924 1-2.999 0-2.757-2.243-5-5-5zm0 7c-1.105 0-2-.895-2-2s.895-2 2-2 2 .895 2 2-.895 2-2 2z"></path>
        <path d="m40 26.382 7.863-10.009c1.378-1.753 2.137-3.947 2.137-6.178v-.195c0-5.514-4.486-10-10-10s-10 4.486-10 10v.195c0 2.23.759 4.425 2.137 6.178zm0-23.382c3.866 0 7 3.134 7 7s-3.134 7-7 7-7-3.134-7-7 3.134-7 7-7z"></path>
        <path d="m22 24h2v2h-2z"></path>
        <path d="m26 24h2v2h-2z"></path>
        <path d="m30 24h2v2h-2z"></path>
      </g>
    </svg>
  );
}
